import loadable from '@loadable/component';
import './PointPush.css';

export default loadable(() => {
  return import('./PointPush.jsx');
});
